import { Box, Typography, Grid, IconButton, Button, Stack, FormControlLabel, Radio, RadioGroup, Checkbox } from "@mui/material";
import { blue, blueGrey, grey } from "@mui/material/colors";
import { FaRegWindowClose } from "@react-icons/all-files/fa/FaRegWindowClose";
import { motion } from "framer-motion";
import { useContext, useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { clientConfig } from "../../awsClientConfig";
import { QualifyEnrollmentRequest } from "../../queries/QualifyEnrollmentRequest";
import GraduatedResClientFormContext from "./graduated-res-client-form-context";
import { ArrowBack, HelpOutline } from '@mui/icons-material';
import { MuiIconButton } from "../../styles/theme/components/icon-button";
import { paths } from "../../paths";


const ProtectionPlanEligibility = () => {
    const { next, enrollmentId, setRecommandedPlan, setUnavailableProtectionPlan, previous } = useContext( GraduatedResClientFormContext );
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [showButton, setShowButton] = useState(true);
    const [selectedOptions, setSelectedOptions] = useState<any>({
      BusinessOwner: false,
      SelfEmployee: false,
      W2Employee: false,
      HomeOwner: false,
      StockSeller: false,
    });
    
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
    const onSelectType = (type: string, isSelected: boolean) => {
      setSelectedOptions({ ...selectedOptions, [type]: !isSelected });
    };

    useEffect(() => {
      if (
        selectedOptions.BusinessOwner ||
        selectedOptions.HomeOwner ||
        selectedOptions.SelfEmployee ||
        selectedOptions.StockSeller ||
        selectedOptions.W2Employee || 
        selectedOptions.TaxDeductionMaximization
      ) {
        setShowButton(false);
      } else {
        setShowButton(true);
      }
    }, [selectedOptions]);
    const client = new clientConfig();
    
    const onBackHandler = () => {
        navigate(paths.dashboard.taxShield.reports);
    }

    const onQualifySubmitHandler = () => {
      setShowButton(true);
      const variables = {
        enrolmentID: enrollmentId,
        answeredQuestions: [
          {
            QuestionKey: "BusinessOwner",
            AnswerKey: selectedOptions.BusinessOwner ? "Yes" : "No",
          },
          {
            QuestionKey: "HomeOwner",
            AnswerKey: selectedOptions.HomeOwner ? "Yes" : "No",
          },
          {
            QuestionKey: "SelfEmployee",
            AnswerKey: selectedOptions.SelfEmployee ? "Yes" : "No",
          },
          {
            QuestionKey: "StockSeller",
            AnswerKey: selectedOptions.StockSeller ? "Yes" : "No",
          },
          {
            QuestionKey: "TaxDeductionMaximization",
            AnswerKey: selectedOptions.TaxDeductionMaximization ? "Yes" : "No",
          },
          {
            QuestionKey: "W2Employee",
            AnswerKey: selectedOptions.W2Employee ? "Yes" : "No",
          },
        ],
  
      };
  
      client
        .mutate({ mutation: QualifyEnrollmentRequest, variables: variables })
        .then((res: any) => {
          if (res.data.QualifyEnrollmentRequest.Result === "Qualify") {
            setRecommandedPlan(
              res.data.QualifyEnrollmentRequest?.RecommendedProtectionPlan
            );
            if (res.data.QualifyEnrollmentRequest?.UnavailableProtectionPlan) {
             setUnavailableProtectionPlan(res.data.QualifyEnrollmentRequest?.UnavailableProtectionPlan);
            } else {
              setUnavailableProtectionPlan(null);
            }
            setShowButton(false);
            next();
          }
        })
        .catch((error: any) => {
          console.log("error", error);
          setShowButton(false);
          navigate("/contact-service");
        });
    };
    
    return (
        <Box sx={{alignItems: 'flex-center',
            p: { xs: 2, md: 6, lg: 4 },
            m: { xs: 2, md: 6, lg: 4 }}}>
              
            <Box sx={{
              alignItems: 'flex-center',
              pl: { xs: 2, md: 6, lg: 4 },
              pr: { xs: 2, md: 6, lg: 4 }
            }}>
              <Button variant="text" sx={{color: '#212636', p:0}} onClick={onBackHandler}> <ArrowBack fontSize='small'/> Back</Button>
              <Typography variant="h5" sx={{ mt: 2 }}>
                Have there been any changes to your tax situation?
              </Typography>
            </Box>    
            
            
            <Box sx={{ p: 3, m:4, border: '1px solid var(--mui-palette-divider)', borderRadius: 1}}>
                <Box className="mb-3 d-flex justify-content-between">
                  <Typography variant="h6">Please select all of the scenarios that apply to your current tax situation:</Typography>
                  <IconButton onClick={handleShow} sx={{m:0, p: 0}} size="small"> <HelpOutline sx={{fontSize: '1.3rem'}}/> </IconButton>
                </Box>
                <Stack component={RadioGroup} spacing={3}>
                  <RadioGroup
                    sx={{
                      '& .MuiFormControlLabel-root': {
                        border: '1px solid var(--mui-palette-divider)',
                        borderRadius: 1,
                        gap: 2,
                        p: 2,
                      },
                    }}
                  >
                    {[
                          { value: 'BusinessOwner', title: 'I own a small business'},
                          { value: 'SelfEmployee', title: 'I am self-employed / independent contractor'},
                          { value: 'W2Employee', title: 'I received a W2'},
                          { value: 'HomeOwner', title: 'I own a home'},
                          { value: 'StockSeller', title: 'I sold stocks, crypto or own rental property'},
                          { value: 'TaxDeductionMaximization', title: 'I want to maximize tax deductions'}
                        ].map((option) => (
                      <FormControlLabel
                        control={<Checkbox checked={selectedOptions[option.value]} 
                            onChange={() => onSelectType(option.value, selectedOptions[option.value])}/>}
                        key={option.value}
                        label={
                          <div>
                            <Typography
                              sx={{
                                color: 'var(--mui-palette-text-primary)',
                              }}
                              variant="inherit"
                            >
                              {option.title}
                            </Typography>
                          </div>
                        }
                        value={option.value}
                      />
                    ))}
                  </RadioGroup>
                  <Box className="d-flex justify-content-end">
                  <Button className="me-2 text-button" onClick={onBackHandler}>Cancel</Button>
                  <Button onClick={onQualifySubmitHandler} disabled={showButton} className="option-primary-button">Continue</Button>
                </Box>
                </Stack>
              </Box>
              
      <Modal show={show} onClose={handleClose} centered aria-labelledby="modal-title" aria-describedby="modal-description">
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '80%',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <IconButton onClick={handleClose} sx={{ position: 'absolute', top: 8, right: 8 }}>
            <FaRegWindowClose />
          </IconButton>
          <Typography id="modal-title" variant="h6" component="h2">
            Determine if You're Self-employed:
          </Typography>
          <Typography id="modal-description" sx={{ mt: 2 }}>
            You are self-employed if you have one or more sources of self-employed income:
          </Typography>
          <ul>
            <li>Independent contractor</li>
            <li>Gig worker (ride-share or delivery driver)</li>
            <li>Freelancer</li>
            <li>Consultant</li>
            <li>Small business owner</li>
            <li>Sole proprietor</li>
            <li>Entrepreneur</li>
            <li>1099-NEC</li>
            <li>1099-K</li>
            <li>Sale of goods/services</li>
            <li>Small Business Income</li>
          </ul>
        </Box>
      </Modal>
    </Box>
    );
  }

  export default ProtectionPlanEligibility;
  